import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store";
import useAxiosClient from "../../hooks/useAxiosClient";
import {
  TMandiBankSofwarePartners,
  TMandiEmployeeDetais,
} from "../../types/markets";
import {
  setBankPartnersData,
  setMandiEmployeesData,
  setSoftwarePartnersData,
} from "../../reducers/marketSlice";

const useGetBankPartnersData = () => {
  const { handleGetCall } = useAxiosClient();
  const dispatch = useDispatch();

  const { adminId, bankPartnersData, mandiEmployeesData } = useSelector(
    (state: TRootState) => ({
      adminId: state.auth.adminId,
      bankPartnersData: state.marketDetails.bankPartnersData,
      mandiEmployeesData: state.marketDetails.mandiEmployeesData,
    })
  );
  const getMandiSoftwarePartners = () => {
    handleGetCall<TMandiBankSofwarePartners[]>(
      `admin/common/partners/adminId/${adminId}?type=SOFTWARE`
    ).then(({ data }) => {
      if (data) {
        dispatch(setSoftwarePartnersData(data));
      } else {
        dispatch(setSoftwarePartnersData([]));
      }
    });
  };
  const getMandiBankPartners = () => {
    handleGetCall<TMandiBankSofwarePartners[]>(
      `admin/common/partners/adminId/${adminId}?type=BANK`
    ).then(({ data }) => {
      if (data) {
        dispatch(setBankPartnersData(data));
      } else {
        dispatch(setBankPartnersData([]));
      }
    });
  };
  const getMandiEmployeesData = () => {
    handleGetCall<TMandiEmployeeDetais[]>(
      `admin/common/employees/adminId/${adminId}`
    ).then(({ data }) => {
      if (data) {
        dispatch(setMandiEmployeesData(data));
      } else {
        dispatch(setMandiEmployeesData([]));
      }
    });
  };

  return {
    bankPartnersData,
    mandiEmployeesData,
    getMandiEmployeesData,
    getMandiSoftwarePartners,
    getMandiBankPartners,
  };
};
export default useGetBankPartnersData;
